import { useState, useEffect } from "react";
import { II } from "../../components/common/Icons";
import PMModal from "./PMModal";
import { usePMData } from "../../context/PMContext";import "../../assets/styles/PM/PMProgressPg.css";

function PMProgressPg() {
  const {
    pmProjects,
    pmTeamMembers,
    pmSchedules,
    addReview,
    getMemberReviews,
    createSchedule,
    loading,
    refreshPMData
  } = usePMData();

  const [selectedProject, setSelectedProject] = useState("");
  const [selectedMember, setSelectedMember] = useState(null);
  const [reviewText, setReviewText] = useState("");
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [memberReviews, setMemberReviews] = useState([]);
  const [successMsg, setSuccessMsg] = useState("");

  const [scheduleForm, setScheduleForm] = useState({
    topic: "",
    date: "",
    time: ""
  });

  useEffect(() => {
    if (pmProjects.length > 0 && !selectedProject) {
      setSelectedProject(pmProjects[0].pid);
    }
  }, [pmProjects, selectedProject]);

  const filteredMembers = pmTeamMembers.filter((m) => m.project === selectedProject);
  const selectedProjectData = pmProjects.find((p) => p.pid === selectedProject);
  const projectSchedules = pmSchedules?.filter((s) => s.project === selectedProject) || [];

  const loadMemberReviews = async (member) => {
    try {
      const reviews = await getMemberReviews(member.user_id);
      setMemberReviews(reviews || []);
      setSelectedMember(member);
      setShowHistoryModal(true);
    } catch (error) {
      console.error("Error loading reviews:", error);
    }
  };

  const handleAddReview = async () => {
    if (!reviewText.trim() || !selectedMember) return;

    try {
      await addReview(selectedMember.user_id, reviewText.trim(), selectedProject);
      setSuccessMsg("Review added successfully!");
      setShowReviewModal(false);
      setSelectedMember(null);
      setReviewText("");
      await refreshPMData();
      setTimeout(() => setSuccessMsg(""), 4000);
    } catch (error) {
      alert("Error adding review: " + error.message);
    }
  };

  const handleCreateSchedule = async () => {
    if (!scheduleForm.topic.trim() || !scheduleForm.date || !scheduleForm.time || !selectedMember) return;

    try {
      const displayDate = new Date(scheduleForm.date).toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric'
      });

      const displayTime = new Date(`2000-01-01T${scheduleForm.time}`).toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });

      await createSchedule({
        userId: selectedMember.user_id,
        empName: selectedMember.name,
        empId: selectedMember.id,
        projectId: selectedProject,
        topic: scheduleForm.topic.trim(),
        date: displayDate,
        time: displayTime
      });

      setSuccessMsg("Discussion scheduled successfully!");
      setShowScheduleModal(false);
      setSelectedMember(null);
      setScheduleForm({ topic: "", date: "", time: "" });
      setTimeout(() => setSuccessMsg(""), 4000);
    } catch (error) {
      alert("Error scheduling: " + error.message);
    }
  };

  if (loading) {
    return (
      <div className="pmprogresspg-inline-1">
        <div className="ob-pending-dot pmprogresspg-inline-2"></div>
        <div className="pmprogresspg-inline-3">Loading team progress...</div>
      </div>);

  }

  return (
    <div>
      <div className="sec">Team Progress & Reviews</div>
      
      {successMsg &&
      <div className="toast">
          {II("chk", 16, { c: "#2563eb" })} {successMsg}
        </div>
      }

      {pmProjects.length === 0 ?
      <div className="cd pmprogresspg-inline-4">
          <div className="pmprogresspg-inline-5">
            No projects assigned. Create a project first.
          </div>
        </div> :

      <>
          <div className="tabs pmprogresspg-inline-6">
            {pmProjects.map((p) =>
          <div
            key={p.pid}
            className={"tab" + (selectedProject === p.pid ? " on" : "")}
            onClick={() => setSelectedProject(p.pid)}>
            
                {p.name}
              </div>
          )}
          </div>

          {selectedProjectData &&
        <div className="cd mb16 pmprogresspg-inline-7">
              <div className="cd-h">
                <div className="cd-t">{selectedProjectData.name}</div>
                <div className="cd-s">Overall Progress: {selectedProjectData.progress}%</div>
              </div>
              <div className="cd-b">
                <div className="pmprogresspg-inline-8">
                  <div>
                    <div className="pmprogresspg-inline-9">Status</div>
                    <span className="chip chip-ip">{selectedProjectData.status}</span>
                  </div>
                  <div>
                    <div className="pmprogresspg-inline-10">Team Size</div>
                    <div className="pmprogresspg-inline-11">{filteredMembers.length}</div>
                  </div>
                  <div>
                    <div className="pmprogresspg-inline-12">Schedules</div>
                    <div className="pmprogresspg-inline-13">
                      {projectSchedules.length}
                    </div>
                  </div>
                  <div>
                    <div className="pmprogresspg-inline-14">HR Partner</div>
                    <div className="pmprogresspg-inline-15">{selectedProjectData.hr_name || 'Not assigned'}</div>
                  </div>
                </div>
              </div>
            </div>
        }

          <div className="cd mb16">
            <div className="cd-h">
              <div className="cd-t">Team Progress</div>
              <div className="cd-s">{filteredMembers.length} members</div>
            </div>
            <div className="cd-b pmprogresspg-inline-16">
              <table className="tbl">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>ID</th>
                    <th>Role</th>
                    <th>Progress</th>
                    <th>Status</th>
                    <th>Last Review</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMembers.length === 0 ?
                <tr>
                      <td colSpan="7" className="pmprogresspg-inline-17">
                        No team members assigned to this project.
                      </td>
                    </tr> :

                filteredMembers.map((m) =>
                <tr key={m.id}>
                        <td className="pmprogresspg-inline-18">{m.name}</td>
                        <td className="pmprogresspg-inline-19">{m.id}</td>
                        <td>{m.project_role || m.role}</td>
                        <td>
                          <div className="pmprogresspg-inline-20">
                            <div className="pmprogresspg-inline-21">
                              <div style={{ "--pmprogresspg-1-width":


                          m.progress + "%", "--pmprogresspg-1-background":
                          m.progress >= 70 ? "#2563eb" : m.progress >= 40 ? "#d97706" : "#ef4444" }} className="pmprogresspg-dyn-1" />

                        
                        
                            </div>
                            <span className="pmprogresspg-inline-22">{m.progress}%</span>
                          </div>
                        </td>
                        <td>
                          <span
                      className="chip pmprogresspg-dyn-2" style={{ "--pmprogresspg-2-background":

                        m.status === "On Track" ? "#eff6ff" : m.status === "Needs Attention" ? "#fff7ed" : "#fef2f2", "--pmprogresspg-2-color":
                        m.status === "On Track" ? "#2563eb" : m.status === "Needs Attention" ? "#d97706" : "#ef4444", "--pmprogresspg-2-border-color":
                        m.status === "On Track" ? "#bfdbfe" : m.status === "Needs Attention" ? "#fed7aa" : "#fecaca" }}>
                      
                      
                            {m.status}
                          </span>
                        </td>
                        <td className="pmprogresspg-inline-23">
                          {m.last_review_date || "—"}
                          {m.last_review_note &&
                    <div className="pmprogresspg-inline-24">
                              {m.last_review_note}
                            </div>
                    }
                        </td>
                        <td>
                          <div className="pmprogresspg-inline-25">
                            <button
                        className="btn btn-s pmprogresspg-inline-26"

                        onClick={() => {
                          setSelectedMember(m);
                          setReviewText("");
                          setShowReviewModal(true);
                        }}>
                        
                              {II("edit", 12)} Review
                            </button>
                            <button
                        className="btn-o btn-s pmprogresspg-inline-27"

                        onClick={() => {
                          setSelectedMember(m);
                          setScheduleForm({ topic: "", date: "", time: "" });
                          setShowScheduleModal(true);
                        }}>
                        
                              {II("clock", 12)} Schedule
                            </button>
                            <button
                        className="btn-o btn-s pmprogresspg-inline-28"

                        onClick={() => loadMemberReviews(m)}
                        title="View Review History">
                        
                              {II("eye", 12)} History
                            </button>
                          </div>
                        </td>
                      </tr>
                )
                }
                </tbody>
              </table>
            </div>
          </div>

          {projectSchedules.length > 0 &&
        <div className="cd">
              <div className="cd-h">
                <div className="cd-t">Scheduled Discussions</div>
                <div className="cd-s">{projectSchedules.length} upcoming</div>
              </div>
              <div className="cd-b pmprogresspg-inline-29">
                <table className="tbl">
                  <thead>
                    <tr>
                      <th>Employee</th>
                      <th>Topic</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {projectSchedules.map((s) =>
                <tr key={s.id}>
                        <td className="pmprogresspg-inline-30">{s.empName}</td>
                        <td>{s.topic}</td>
                        <td>{s.date}</td>
                        <td>{s.time}</td>
                        <td>
                          <span className="chip chip-ip">{s.status}</span>
                        </td>
                      </tr>
                )}
                  </tbody>
                </table>
              </div>
            </div>
        }
        </>
      }

      <PMModal
        open={showReviewModal}
        onClose={() => {
          setShowReviewModal(false);
          setSelectedMember(null);
          setReviewText("");
        }}
        title={`Add Review — ${selectedMember?.name || ""}`}>
        
        {selectedMember &&
        <div>
            <div className="pmprogresspg-inline-31">





            
              <div className="pmprogresspg-inline-32">{selectedMember.name}</div>
              <div className="pmprogresspg-inline-33">
                {selectedMember.id} · {selectedMember.role} · Progress: {selectedMember.progress}% · {selectedMember.status}
              </div>
            </div>

            <div className="fg">
              <label className="fl">Review Comment *</label>
              <textarea
              className="fta"
              rows={4}
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
              placeholder="Enter your review notes, feedback, or observations..." />
            
            </div>

            <div className="pmprogresspg-inline-34">
              <button className="btn-o" onClick={() => setShowReviewModal(false)}>Cancel</button>
              <button className="btn" onClick={handleAddReview}>
                {II("chk", 14)} Save Review
              </button>
            </div>
          </div>
        }
      </PMModal>

      <PMModal
        open={showScheduleModal}
        onClose={() => {
          setShowScheduleModal(false);
          setSelectedMember(null);
          setScheduleForm({ topic: "", date: "", time: "" });
        }}
        title={`Schedule Discussion — ${selectedMember?.name || ""}`}>
        
        {selectedMember &&
        <div>
            <div className="pmprogresspg-inline-35">





            
              <div className="pmprogresspg-inline-36">{selectedMember.name}</div>
              <div className="pmprogresspg-inline-37">
                {selectedMember.id} · {selectedMember.role}
              </div>
            </div>

            <div className="fg">
              <label className="fl">Topic *</label>
              <input
              className="fi"
              value={scheduleForm.topic}
              onChange={(e) => setScheduleForm({ ...scheduleForm, topic: e.target.value })}
              placeholder="e.g. Sprint review follow-up, Code review, 1:1 meeting" />
            
            </div>
            
            <div className="fr2">
              <div className="fg">
                <label className="fl">Date *</label>
                <input
                className="fi"
                type="date"
                value={scheduleForm.date}
                onChange={(e) => setScheduleForm({ ...scheduleForm, date: e.target.value })}
                min={new Date().toISOString().split('T')[0]} />
              
              </div>
              <div className="fg">
                <label className="fl">Time *</label>
                <input
                className="fi"
                type="time"
                value={scheduleForm.time}
                onChange={(e) => setScheduleForm({ ...scheduleForm, time: e.target.value })} />
              
              </div>
            </div>

            <div className="pmprogresspg-inline-38">
              <span className="pmprogresspg-inline-39">Note:</span> Meeting will be scheduled and visible to the employee.
            </div>

            <div className="pmprogresspg-inline-40">
              <button className="btn-o" onClick={() => setShowScheduleModal(false)}>Cancel</button>
              <button className="btn" onClick={handleCreateSchedule}>
                {II("chk", 14)} Schedule Meeting
              </button>
            </div>
          </div>
        }
      </PMModal>

      <PMModal
        open={showHistoryModal}
        onClose={() => {
          setShowHistoryModal(false);
          setSelectedMember(null);
          setMemberReviews([]);
        }}
        title={`Review History — ${selectedMember?.name || ""}`}
        wide={true}>
        
        {selectedMember &&
        <div>
            <div className="pmprogresspg-inline-41">
              <div className="pmprogresspg-inline-42">
                <div>
                  <div className="pmprogresspg-inline-43">{selectedMember.name}</div>
                  <div className="pmprogresspg-inline-44">
                    {selectedMember.id} · {selectedMember.role} · Current Progress: {selectedMember.progress}%
                  </div>
                </div>
                <span className="chip pmprogresspg-dyn-3" style={{ "--pmprogresspg-3-background":
                selectedMember.status === "On Track" ? "#eff6ff" : "#fff7ed", "--pmprogresspg-3-color":
                selectedMember.status === "On Track" ? "#2563eb" : "#d97706" }}>
                
                  {selectedMember.status}
                </span>
              </div>
            </div>

            {memberReviews.length === 0 ?
          <div className="pmprogresspg-inline-45">
                <div className="pmprogresspg-inline-46">📝</div>
                <div className="pmprogresspg-inline-47">No Reviews Yet</div>
                <div className="pmprogresspg-inline-48">Add your first review for this team member.</div>
              </div> :

          <div className="pmprogresspg-inline-49">
                {memberReviews.map((review, index) =>
            <div
              key={index} style={{ "--pmprogresspg-4-border-bottom":


                index < memberReviews.length - 1 ? "1px solid #e2e8f0" : "none", "--pmprogresspg-4-background":
                index % 2 === 0 ? "#fff" : "#f8fafc" }} className="pmprogresspg-dyn-4">
              
              
                    <div className="pmprogresspg-inline-50">
                      <span className="pmprogresspg-inline-51">
                        {review.by}
                      </span>
                      <span className="pmprogresspg-inline-52">
                        {review.date}
                      </span>
                    </div>
                    <div className="pmprogresspg-inline-53">
                      {review.note}
                    </div>
                  </div>
            )}
              </div>
          }

            <div className="pmprogresspg-inline-54">
              <button className="btn" onClick={() => {
              setShowHistoryModal(false);
              setReviewText("");
              setShowReviewModal(true);
            }}>
                {II("edit", 14)} Add New Review
              </button>
              <button className="btn-o" onClick={() => setShowHistoryModal(false)}>Close</button>
            </div>
          </div>
        }
      </PMModal>
    </div>);

}

export default PMProgressPg;